<script>
import * as C from '../../variables/reviewElementTypes';
import ReviewService from '../../services/review-service';

export default {
  name: 'ReviewRatingsContainer',
  props: {
    categoryRatings: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      campsiteCategories: this.getCampsiteCategories(this.categoryRatings),
      accommodationCategories: this.getAccommodationCategories(this.categoryRatings),
    };
  },
  methods: {
    getCampsiteCategories(categoryRatings) {
      return categoryRatings.filter(element => element.type === C.REVIEW_CATEGORY_RATINGS);
    },
    getAccommodationCategories(categoryRatings) {
      return categoryRatings.filter(element => element.type === C.REVIEW_ACCOMMODATION_RATINGS);
    },
    doubleRoundScore(score) {
      return ReviewService.doubleRoundScore(score);
    },
  },
};
</script>

<template>
  <div>
    <v-card-text class="mx-2">
      <v-layout>
        <v-flex>
          <h3>{{ $t('review.reviewInformationContainer.campsiteRatings')}}</h3>
          <br>
          <div v-for="campsiteCategory in campsiteCategories" :key="campsiteCategory.id">
            <v-layout>
              <v-flex>
                {{ campsiteCategory.category }}:
              </v-flex>
              <v-flex xs2>
                {{ doubleRoundScore(campsiteCategory.score) }}
              </v-flex>
            </v-layout>
          </div>
        </v-flex>
        <v-flex xs6>
          <h3>{{ $t('review.reviewInformationContainer.accommodationRatings')}}</h3>
          <br>
          <div
            v-for="accommodationCategory in accommodationCategories"
            :key="accommodationCategory.id"
          >
            <v-layout>
              <v-flex>
                {{ accommodationCategory.category }}:
              </v-flex>
              <v-flex xs4>
               {{ doubleRoundScore(accommodationCategory.score) }}
              </v-flex>
            </v-layout>
          </div>
        </v-flex>
      </v-layout>
    </v-card-text>
    <v-divider class="mx-3"/>
  </div>
</template>



// WEBPACK FOOTER //
// src/components/review/ReviewRatingsContainer.vue